import { useHostname } from '@bv/composables/common/hostname';
import { getRouter } from '@bv/plugins/router';
import { useBrandStore } from '@bv/stores/brand';
import { getConsoleUrl } from '@bv/utils/url/console/get-url';
import { normalizeUrlPath } from '@bv/utils/url/normalize-path';

type Target = '_self' | '_blank';

/**
 * Navigates the user to the console subdomain if the current subdomain
 * doesn't match the configured console subdomain, or pushes the path
 * in-app when already on the console.
 *
 * @param path - The path to navigate to
 *
 * @example
 * goToConsole('dashboard');
 * // will redirect to https://console.example.com/dashboard
 */
export const goToConsole = (path?: string, target?: Target): void => {
  const targetValue = target || '_self';
  const { subdomain } = useHostname();
  const consoleSubdomain: string | undefined = useBrandStore().config?.subdomains.console;

  if (consoleSubdomain && consoleSubdomain !== subdomain && import.meta.env.VITE_IS_CONSOLE !== 'true') {
    window.open(getConsoleUrl(path), targetValue);
  } else if (import.meta.env.VITE_IS_CONSOLE === 'true' && path !== undefined) {
    getRouter()?.push({ path: normalizeUrlPath(path) });
  }
};
